import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgSentMail = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M14.6667 4H6C5.26667 4 4.66667 4.58643 4.66667 5.30317V11.1674C4.66667 11.513 4.80714 11.8445 5.05719 12.0889C5.30724 12.3333 5.64638 12.4706 6 12.4706H14.6667C15.4067 12.4706 16 11.8907 16 11.1674V5.30317C16 4.95755 15.8595 4.62608 15.6095 4.38169C15.3594 4.1373 15.0203 4 14.6667 4ZM14.6667 11.1674H6V6.39131L10.3333 8.56109L14.6667 6.39131V11.1674ZM10.3333 7.45991L6 5.30317H14.6667L10.3333 7.45991ZM3.33333 11.1674C3.33333 11.2782 3.35333 11.3824 3.36667 11.4932H0.666667C0.298667 11.4932 0 11.2 0 10.8416C0 10.4833 0.298667 10.19 0.666667 10.19H3.33333V11.1674ZM2 4.97738H3.36667C3.35333 5.08814 3.33333 5.1924 3.33333 5.30317V6.28054H2C1.63333 6.28054 1.33333 5.98733 1.33333 5.62896C1.33333 5.27059 1.63333 4.97738 2 4.97738ZM0.666667 8.23529C0.666667 7.87692 0.966667 7.58371 1.33333 7.58371H3.33333V8.88688H1.33333C0.966667 8.88688 0.666667 8.59367 0.666667 8.23529Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgSentMail)
const IconSvgSentMail = createIcon(ForwardRef, 'SvgSentMail')
export default IconSvgSentMail
